import SurveyFormat from './surveyFormatEnum';

export const extrapolateSurveyData = (survey = {}) => {
  if (Object.entries(survey).length === 0) {
    return {};
  }

  return {
    surveyTitle: survey.title,
    surveyTitleHTML: survey.titleHTML,
    isSurveyTitleEnabled: survey.design.surveyTitle.enabled,
    showPageTitles: survey.design.showPageTitles,
    showRequiredQuestionAsterisks: survey.design.showRequiredQuestionAsterisks,
    isQuestionNumberingEnabled: survey.design.questionNumbering.enabled,
    isFooterEnabled: survey.design.footer.enabled,
    isLogoEnabled: survey.design.logo.enabled,
    questions: survey.questionsQM?.items ?? [],
    langCode: survey.language?.code,
    isAutoScroll: survey.format === SurveyFormat.OQAAT,
    totalQuestionsCount: survey?.questionCount,
    surveyPages: survey.pages?.items || [],
    logoProps: survey.design.logo,
    surveyTitleAlignment: survey.design.surveyTitle.horizontalAlignment,
  };
};

export default extrapolateSurveyData;
